
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"m21.4283 14.3574c0 .4346-.3524.7852-.7852.7852h-3.9278v-5.5c0-1.30211-1.0553-2.35561-2.3574-2.3574h-5.50001v-3.9278c0-.43464.35235-.7852.7852-.7852h11.00001c.4346 0 .7852.35235.7852.7852zm-6.2852 6.2852c0 .4346-.3524.7852-.7852.7852h-11.00001c-.43464 0-.78521-.3524-.78521-.7852v-11c0-.43463.35236-.7852.78521-.7852h11.00001c.4346 0 .7852.35236.7852.7852zm5.5-19.6426h-11.00001c-1.30211 0-2.35561 1.05528-2.3574 2.3574v3.9278h-3.9278c-1.30033 0-2.35561 1.05529-2.3574 2.3574v11c0 1.3021 1.05528 2.3556 2.3574 2.3574h11.00001c1.3021 0 2.3556-1.0553 2.3574-2.3574v-3.9278h3.9278c1.3021 0 2.3556-1.0553 2.3574-2.3574v-11c0-1.30033-1.0553-2.35561-2.3574-2.3574z","fill":"#4a3428"}})])
          )
        }
      }
    